import _regeneratorRuntime from "babel-runtime/regenerator";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _this = this;

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

import { fabric } from "fabric";
import { fourDimensionalCanvas, framedCanvas } from "../Misc/CanvasDecorators";
var framesCache = {
  raw: {},
  decorated: {},
  "raw-playButton": {},
  "decorated-playButton": {}
};
var videos = {};
var timePoints = {};

var getVideo = function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(src) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!videos[src]) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", videos[src].video || videos[src].promise);

          case 2:
            videos[src] = {};
            videos[src].promise = new Promise(function (r) {
              var video = document.createElement("video");
              video.crossOrigin = "anonymous";
              video.muted = true;
              video.src = src;
              video.addEventListener("canplay", function () {
                videos[src].video = video;
                r(video);
              });

              var errorListener = function errorListener() {
                videos[src].video = null;
                r(null);
              };

              video.addEventListener("error", errorListener);
              video.addEventListener("abort", errorListener);
              videos[src].player = video;
            });
            videos[src].player.load();
            return _context.abrupt("return", videos[src].promise);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function getVideo(_x) {
    return _ref.apply(this, arguments);
  };
}();

function promiseGrab(videoSrc, time, quality, maxSize, decoration, playButton) {
  var _this2 = this;

  return new Promise(function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(r) {
      var type, cachedFrames, cachedFrame, canvas, video, width, height, scale, grabFrameCallback;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              type = [decoration ? "decorated" : "raw", playButton ? "playButton" : null].filter(function (val) {
                return !!val;
              }).join("-");
              cachedFrames = framesCache[type][videoSrc] || {};
              cachedFrame = cachedFrames[time];

              if (!cachedFrame) {
                _context3.next = 6;
                break;
              }

              r(cachedFrame);
              return _context3.abrupt("return");

            case 6:
              canvas = document.createElement("canvas");
              _context3.next = 9;
              return getVideo(videoSrc);

            case 9:
              video = _context3.sent;

              if (video) {
                _context3.next = 13;
                break;
              }

              r(null);
              return _context3.abrupt("return");

            case 13:
              if (!(video.duration <= time)) {
                _context3.next = 16;
                break;
              }

              r(null);
              return _context3.abrupt("return");

            case 16:
              width = video.videoWidth, height = video.videoHeight;
              video.width = width;
              video.height = height;
              scale = 1;

              if (maxSize && (width > maxSize || height > maxSize)) {
                scale = maxSize / Math.max(width, height);
              }

              canvas.width = width;
              canvas.height = height; // because we use single video object to grab multiple frames we need to organize something like a queue
              // so check here is the queue for given video created and create new one

              if (!timePoints[videoSrc]) {
                timePoints[videoSrc] = [];
              } // push given time point to the queue


              timePoints[videoSrc].push(time); // if time point was first, start processing it immediately

              if (timePoints[videoSrc].length === 1) {
                video.currentTime = time;
              }

              grabFrameCallback = function () {
                var _ref3 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee2() {
                  var _extends2;

                  var fabricCanvas, frame, framedFrame;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!(video.currentTime.toFixed(2) !== time.toFixed(2))) {
                            _context2.next = 2;
                            break;
                          }

                          return _context2.abrupt("return");

                        case 2:
                          _context2.next = 4;
                          return decorateVideoFrame(canvas, video, decoration, playButton);

                        case 4:
                          fabricCanvas = _context2.sent;
                          frame = fabricCanvas.toDataURL({
                            format: "jpeg",
                            multiplier: scale,
                            quality: quality
                          });
                          _context2.next = 8;
                          return renderFrame(frame, decoration, scale);

                        case 8:
                          framedFrame = _context2.sent;
                          framesCache[type][videoSrc] = _extends({}, framesCache[type][videoSrc] || {}, (_extends2 = {}, _extends2[time] = framedFrame, _extends2));
                          r(framedFrame);
                          video.removeEventListener("timeupdate", grabFrameCallback); // remove time point from queue and start processing next one

                          timePoints[videoSrc].shift();

                          if (timePoints[videoSrc].length > 0) {
                            video.currentTime = timePoints[videoSrc][0];
                          }

                        case 14:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                }));

                return function grabFrameCallback() {
                  return _ref3.apply(this, arguments);
                };
              }();

              video.addEventListener("timeupdate", grabFrameCallback);

            case 28:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }());
}

var decorateVideoFrame = function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(canvas, video) {
    var decoration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var playButton = arguments[3];
    var fabricCanvas;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            fabricCanvas = framedCanvas(fourDimensionalCanvas(new fabric.StaticCanvas(canvas, {
              enableRetinaScaling: false
            })));

            if (!decoration.overlay) {
              _context4.next = 4;
              break;
            }

            _context4.next = 4;
            return renderOverlay(fabricCanvas, decoration.overlay, video.currentTime);

          case 4:
            if (!decoration.customFrameSource) {
              _context4.next = 7;
              break;
            }

            _context4.next = 7;
            return renderCustomFrame(fabricCanvas, decoration.customFrameSource);

          case 7:
            _context4.next = 9;
            return setVideoBackground(fabricCanvas, video);

          case 9:
            if (!playButton) {
              _context4.next = 12;
              break;
            }

            _context4.next = 12;
            return renderPlayButton(fabricCanvas);

          case 12:
            if (!decoration.logo) {
              _context4.next = 15;
              break;
            }

            _context4.next = 15;
            return renderLogo(fabricCanvas, decoration.logo);

          case 15:
            return _context4.abrupt("return", fabricCanvas);

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function decorateVideoFrame(_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}();

var renderCustomFrame = function renderCustomFrame(fabricCanvas, customFrameSource) {
  return new Promise(function (r) {
    fabric.Image.fromURL(customFrameSource + "?" + new Date().getTime(), function (img) {
      var coords = {
        left: 0,
        top: 0,
        scaleX: fabricCanvas.width / img.width,
        scaleY: fabricCanvas.height / img.height
      };
      img.set(_extends({}, coords));
      fabricCanvas.add(img);
      fabricCanvas.moveTo(img, 0);
      r();
    }, {
      crossOrigin: "Anonymous"
    });
  });
};

var setVideoBackground = function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(fabricCanvas, video) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", new Promise(function (r) {
              var videoEl = new fabric.Image(video, {
                left: 0,
                top: 0,
                width: fabricCanvas.width,
                height: fabricCanvas.height,
                metadata: {
                  start: 0,
                  duration: 1
                }
              });
              fabricCanvas.setBackgroundImage(videoEl, function () {
                fabricCanvas.renderAll();
                r();
              });
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function setVideoBackground(_x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();

var renderOverlay = function renderOverlay(fabricCanvas, overlay, time) {
  var modifiedOverlay = _extends({}, overlay, {
    objects: overlay.objects.map(function (object) {
      if (object.type === "image") {
        object.crossOrigin = "Anonymous";
        object.src += "?" + new Date().getTime();
      }

      return object;
    })
  });

  return new Promise(function (r) {
    fabricCanvas.loadFromJSON(modifiedOverlay, function () {
      fabricCanvas.renderAll();
      fabricCanvas.alignToTime(time);
      r();
    });
  });
};

var renderPlayButton = function renderPlayButton(fabricCanvas) {
  var size = fabricCanvas.width * 0.2;
  var triangleSize = size * 0.4;
  var coords = {
    originX: "center",
    originY: "center",
    left: fabricCanvas.width / 2,
    top: fabricCanvas.height / 2
  };
  fabricCanvas.add(new fabric.Circle(_extends({}, coords, {
    radius: size / 2,
    stroke: "white",
    strokeWidth: size * 0.05,
    fill: ""
  })));
  fabricCanvas.add(new fabric.Polygon([{
    x: 0,
    y: 0
  }, {
    x: triangleSize,
    y: triangleSize / 2
  }, {
    x: 0,
    y: triangleSize
  }], _extends({}, coords, {
    left: coords.left + triangleSize * 0.2,
    fill: "white"
  })));
};

var renderLogo = function renderLogo(fabricCanvas, logoSettings) {
  var url = logoSettings.url,
      left = logoSettings.left,
      top = logoSettings.top,
      _logoSettings$right = logoSettings.right,
      right = _logoSettings$right === undefined ? 50 : _logoSettings$right,
      _logoSettings$bottom = logoSettings.bottom,
      bottom = _logoSettings$bottom === undefined ? 50 : _logoSettings$bottom,
      _logoSettings$size = logoSettings.size,
      size = _logoSettings$size === undefined ? 20 : _logoSettings$size;
  return new Promise(function (r) {
    fabric.Image.fromURL(url + "?" + new Date().getTime(), function (img) {
      var coords = {};

      if (right > 0) {
        coords.originX = "right";
        coords.left = fabricCanvas.width - right;
      } else {
        coords.left = left;
      }

      if (bottom > 0) {
        coords.originY = "bottom";
        coords.top = fabricCanvas.height - bottom;
      } else {
        coords.top = top;
      }

      img.set(_extends({}, coords));

      if (img.width > img.height) {
        img.scaleToWidth(fabricCanvas.width * size / 100);
      } else {
        img.scaleToHeight(fabricCanvas.height * size / 100);
      }

      fabricCanvas.add(img);
      r();
    }, {
      crossOrigin: "Anonymous"
    });
  });
};

var renderFrame = function renderFrame(thumbnail) {
  return new Promise(function (r) {
    if (thumbnail === "data:,") {
      r(thumbnail);
      return;
    }

    fabric.Image.fromURL(thumbnail, function (img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var fabricCanvas = fourDimensionalCanvas(new fabric.StaticCanvas(canvas));
      img.set({
        top: 0,
        left: 0
      });
      fabricCanvas.add(img);
      r(fabricCanvas.toDataURL({
        format: "jpeg",
        multiplier: 1,
        quality: 1
      }));
    });
  });
};

export var grabVideoFrame = function () {
  var _ref6 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(videoSrc, time, quality, maxSize, decoration, playButton) {
    var sources, i, frame;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            sources = videoSrc instanceof Array ? videoSrc : [videoSrc];
            _context6.t0 = _regeneratorRuntime.keys(sources);

          case 2:
            if ((_context6.t1 = _context6.t0()).done) {
              _context6.next = 11;
              break;
            }

            i = _context6.t1.value;
            _context6.next = 6;
            return promiseGrab(sources[i], time, quality, maxSize, decoration, playButton);

          case 6:
            frame = _context6.sent;

            if (!(frame && frame !== "data:,")) {
              _context6.next = 9;
              break;
            }

            return _context6.abrupt("return", frame);

          case 9:
            _context6.next = 2;
            break;

          case 11:
            return _context6.abrupt("return", null);

          case 12:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function grabVideoFrame(_x8, _x9, _x10, _x11, _x12, _x13) {
    return _ref6.apply(this, arguments);
  };
}();